import { TFunction } from './i18n/hooks/useT';

const pageTitleMap = {
  signup: (t: TFunction) =>
    t('PageTitle.Signup', 'Sign up | Anchor', 'Sign up page title'),
  login: (t: TFunction) =>
    t('PageTitle.Login', 'Login | Anchor', 'Login page title'),
  anchorFeatures: (t: TFunction) =>
    t(
      'PageTitle.AnchorFeatures',
      'Features | Anchor',
      'Anchor features page title'
    ),
  switchToAnchor: (t: TFunction) =>
    t(
      'PageTitle.SwitchToAnchor',
      'Switch to Anchor',
      'Switch to anchor page title'
    ),
  adsByAnchor: (t: TFunction) =>
    t('PageTitle.AdsByAnchor', 'Ads by Anchor', 'Ads by anchor page title'),
  termsOfService: (t: TFunction) =>
    t(
      'PageTitle.TermsOfService',
      'Terms of Service | Anchor',
      'Anchor Terms of Service page title'
    ),
  network: (t: TFunction) =>
    t('PageTitle.Network', 'Network | Anchor', 'Network page title'),
  dashboard: (t: TFunction) =>
    t('PageTitle.Dashboard', 'Dashboard | Anchor', 'Dashboard page title'),
  episodesList: (t: TFunction) =>
    t(
      'PageTitle.EpisodesList',
      'Episodes list | Anchor',
      'Episodes list page title'
    ),
  money: (t: TFunction) =>
    t(
      'PageTitle.Monetization',
      'Monetization | Anchor',
      'Monetization page title'
    ),
  newEpisode: (t: TFunction) =>
    t(
      'PageTitle.NewEpisode',
      'Create new episode | Anchor',
      'New Episode page title'
    ),
  settings: (t: TFunction) =>
    t('PageTitle.Settings', 'Update settings | Anchor', 'Settings page title'),
  podcastAvailability: (t: TFunction) =>
    t(
      'PageTitle.PodcastAvailability',
      'Podcast Availability | Anchor',
      'Podcast Availability page title'
    ),
  getOnSpotify: (t: TFunction) =>
    t(
      'PageTitle.GetOnSpotify',
      'Make your own podcast',
      'Get on Spotify page title'
    ),
  videoPartnerScreen: (t: TFunction) =>
    t(
      'PageTitle.VideoPartnerLander',
      'Video Podcasts | Anchor',
      'Video Partner lander page title'
    ),
};

export type Page = keyof typeof pageTitleMap;

export function getPageTitle(page: Page, t: TFunction) {
  return page && pageTitleMap[page]
    ? pageTitleMap[page](t)
    : t(
        'PageTitle.Default',
        'Anchor - The easiest way to make a podcast',
        'Default page title'
      );
}
